import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export function InlineCode(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("code", _object_spread({
        className: clsx("text-red-500 dark:text-red-400 tracking-wide font-medium bg-gray-200", "mx-1 py-px px-1 rounded text-[85%] ", "dark:bg-gray-900/70", className)
    }, rest));
}
